import { createSlice } from "@reduxjs/toolkit";

interface PaginationState {
  currentPage: number | string;
  postsPerPage: number | string;
}

const initialState: PaginationState = {
  currentPage: 1,
  postsPerPage: 10,
};

const paginationSlice = createSlice({
  name: "paginationSlice",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPostsPerPage: (state, action) => {
      state.postsPerPage = action.payload;
    },
  },
});

export const { setCurrentPage, setPostsPerPage } = paginationSlice.actions;
export const pagination = paginationSlice.reducer;
